import React from 'react';
import './LegalPages.css';

const TermsOfUse = () => {
  return (
    <div className="legal-page-container">
      <h1 className="legal-title">תנאי שימוש – אורבניקס (Urbanix)</h1>
      <p className="legal-subtitle">עדכון אחרון: {new Date().toLocaleDateString('he-IL')}</p>

      <div className="legal-section">
        <p className="legal-text">
          ברוכים הבאים לאתר אורבניקס (urbanix.ai) ולשירותי יועץ הנדל"ן-AI שלנו (להלן יחד: "השירות").
        </p>
        <p className="legal-text">
          השימוש באתר ובשירות כפוף לתנאי שימוש אלה (להלן: "התנאים"). אנא קרא/י אותם בעיון לפני השימוש.
        </p>
        <p className="legal-text">
          על ידי כניסה לאתר, גלישה בו, שימוש בכלי ניתוח, קבלת דוחות או הרשמה לשירות – אתה מאשר/ת שקראת את התנאים, הבנת אותם, ואת/ה מסכים/ה להם. אם אינך מסכים/ה – אנא הימנע/י משימוש באתר.
        </p>
        <p className="legal-text">
          <strong>הבהרה חשובה:</strong> תנאים אלה הם טיוטה כללית ואינם מהווים ייעוץ משפטי. לפני אימוצם הסופי מומלץ להיוועץ בעו״ד.
        </p>
      </div>

      <div className="legal-section">
        <h3>1. הגדרות</h3>
        <p className="legal-text">בתנאים אלה:</p>
        <ul className="legal-list">
          <li><strong>"החברה" / "אנחנו" / "אורבניקס"</strong> – מפעילי האתר והשירות urbanix.ai.</li>
          <li><strong>"האתר"</strong> – כל הדפים, התכנים, הקבצים והממשקים בכתובת urbanix.ai וכל כתובת אחרת שאליה נפנה.</li>
          <li><strong>"השירות"</strong> – לרבות כל כלי, דוח, ניתוח, שכבת נתונים, שירות AI, ממשק מפה, חומרי מידע ותוכן אחר הניתן באמצעות האתר.</li>
          <li><strong>"משתמש" / "אתה"</strong> – כל אדם או גוף המשתמש באתר או בשירות, לרבות ללא הרשמה.</li>
        </ul>
      </div>

      <div className="legal-section">
        <h3>2. תיאור השירות</h3>
        <p className="legal-text">
          אורבניקס היא פלטפורמת מידע וניתוח נדל"ני שמטרתה לרכז במקום אחד מידע מבוזר לגבי נכסים, חלקות וקרקעות בישראל, להנגיש אותו בצורה פשוטה ונהירה, ולספק שכבת "יועץ נדל"ן AI", לרבות:
        </p>
        <ul className="legal-list">
          <li>הצגת נתונים סטטוטוריים, תכנוניים, עיסקיים וציבוריים.</li>
          <li>הפקת דוחות סטטיים ומתעדכנים (ממודולריים ועד תרחישים דינמיים).</li>
          <li>אינדיקציות לפוטנציאל התחדשות עירונית, "פליפ", שיפור נכס, שימושים אפשריים ועוד.</li>
          <li>ניתוחים, הערכות ו"המלצות" חכמות המבוססות על אלגוריתמים של בינה מלאכותית.</li>
        </ul>
        <p className="legal-text">
          השירות הוא שירות מידע וניטור בלבד, ואינו מהווה תחליף לייעוץ מקצועי פרטני מכל סוג.
        </p>
      </div>

      <div className="legal-section">
        <h3>3. אין ייעוץ משפטי / תכנוני / שמאי / פיננסי</h3>
        <p className="legal-text">המידע, הדוחות והתוצרים המופקים באתר:</p>
        <ul className="legal-list">
          <li>אינם מהווים ייעוץ משפטי, תכנוני, שמאי, פיננסי, מיסויי או השקעות.</li>
          <li>אינם מחליפים בדיקה רשמית במערכות התכנון, הרשויות המקומיות, שמאי מקרקעין, יועצים מקצועיים או כל גורם מוסמך אחר.</li>
          <li>עשויים להתבסס על נתונים ציבוריים/צד שלישי שאינם תמיד מעודכנים, מלאים או חפים מטעויות.</li>
        </ul>
        <p className="legal-text">
          לפני כל פעולה משפטית, תכנונית או פיננסית – עליך לפנות לאנשי מקצוע מוסמכים ולמידע הרשמי.
          <br />
          <strong>אינך רשאי להסתמך אך ורק על השירות לצורך קבלת החלטות בעלות משמעות כלכלית/משפטית.</strong>
        </p>
      </div>

      <div className="legal-section">
        <h3>4. תנאי סף לשימוש</h3>
        <ul className="legal-list">
          <li>השימוש באתר מותר לגולשים בני 18 ומעלה בלבד.</li>
          <li>אתה מצהיר שהשימוש שלך בשירות נעשה לטובתך בלבד או בשם גוף שהסמיך אותך כדין.</li>
          <li>אתה מתחייב להשתמש בשירות בהתאם לדין הישראלי ולכל דין זר החל עליך, ובכפוף לתנאים אלו בלבד.</li>
        </ul>
      </div>

      <div className="legal-section">
        <h3>5. שימוש מותר ושימוש אסור</h3>
        <p className="legal-text"><strong>5.1 שימוש מותר</strong></p>
        <p className="legal-text">מותר להשתמש באתר ובשירות לצורך:</p>
        <ul className="legal-list">
          <li>קבלת מידע וניתוח ראשוני על נכסים, חלקות וקרקעות.</li>
          <li>בחינת פוטנציאל כללי של פרויקטים נדל"ניים.</li>
          <li>קבלת אינדיקציות והכוונה ראשונית לפני פנייה לגורמים מקצועיים.</li>
        </ul>

        <p className="legal-text"><strong>5.2 שימוש אסור</strong></p>
        <p className="legal-text">אסור:</p>
        <ul className="legal-list">
          <li>להשתמש בשירות לכל מטרה בלתי חוקית.</li>
          <li>להעתיק, לשכפל, לשאוב נתונים באופן שיטתי (Scraping) או להוריד מסדי נתונים ללא הרשאה מראש ובכתב.</li>
          <li>לעקוף, לשבש או לנסות לעקוף מנגנוני אבטחה, הגבלת גישה או כל טכנולוגיה המגינה על השירות.</li>
          <li>לבצע "הנדסה לאחור" של מערכות האתר, לרבות מודלי ה-AI.</li>
          <li>להשתמש בשירות לצורך ניתוח או יצירת מאגר מתחרה או לצורך מתן שירות מסחרי דומה ללא הסכמת החברה.</li>
          <li>להזין מידע שקרי, מטעה או שמפר זכויות של צדדים שלישיים (לרבות זכויות יוצרים, פרטיות וסודיות).</li>
          <li>להזין או להפיץ דרך השירות קוד זדוני, וירוסים, ספאם וכדומה.</li>
        </ul>
        <p className="legal-text">
          החברה רשאית, לפי שיקול דעתה, לחסום או להגביל משתמש שמפר תנאים אלה.
        </p>
      </div>

      <div className="legal-section">
        <h3>6. הרשמה, חשבונות וגישה</h3>
        <p className="legal-text">ככל שהאתר מציע אפשרות לפתיחת חשבון משתמש:</p>
        <ul className="legal-list">
          <li>עליך למסור פרטים נכונים, מדויקים ומעודכנים.</li>
          <li>עליך לשמור על סודיות פרטי ההתחברות ולא להעבירם לצדדים שלישיים.</li>
          <li>אתה נושא באחריות לכל פעולה שתעשה בחשבונך.</li>
          <li>החברה רשאית לסרב לפתוח חשבון, לסגור חשבון קיים או להגביל גישה – לפי שיקול דעתה.</li>
        </ul>
      </div>

      <div className="legal-section">
        <h3>7. שירותים בתשלום</h3>
        <p className="legal-text">
          ייתכן שחלק מהשירותים באתר יינתנו בתשלום (כגון: דוחות מורחבים, מנוי מקצועי, API, וכיו"ב).
        </p>
        <ul className="legal-list">
          <li>המחירים, תנאי התשלום ומדיניות הביטול יפורסמו באתר וישתנו מעת לעת.</li>
          <li>אם וככל שתבצע רכישה – תנאי התשלום שיופיעו בדף הרכישה יהוו חלק בלתי נפרד מתנאים אלה.</li>
          <li>החברה רשאית לשנות מחירים ותנאים, ויחולו על רכישות עתידיות בלבד, אלא אם צוין אחרת במפורש.</li>
        </ul>
      </div>

      <div className="legal-section">
        <h3>8. זכויות קניין רוחני</h3>
        <ul className="legal-list">
          <li>כל זכויות היוצרים, סימני המסחר, העיצובים, הקוד, מסדי הנתונים, מודלי ה-AI, הטקסטים, הגרפים והאיקונים – כולם בבעלות החברה ו/או צדדים שלישיים שהסמיכו אותה.</li>
          <li>הנתונים שמקורם במאגרים ציבוריים ו/או רשויות שייכים לגופים המפרסמים, והשימוש בהם באתר הוא לשם הצגה נוחה בלבד בהתאם לתנאים שלהם.</li>
          <li>אין להעתיק, להפיץ, לפרסם מחדש, לשדר, להציג בפומבי, לעבד או לעשות שימוש מסחרי כלשהו בתכנים ללא הסכמה מראש ובכתב מאת החברה.</li>
          <li>החברה מעניקה לך רישיון אישי, בלתי בלעדי, לא ניתן להעברה וניתן לביטול, להשתמש בשירות לצרכים פנימיים בלבד ובכפוף לתנאים אלה.</li>
        </ul>
      </div>

      <div className="legal-section">
        <h3>9. תוכן שמוזן על ידך</h3>
        <p className="legal-text">
          בעת שימושך בשירות, אתה עשוי להזין מידע ותוכן (למשל: פרטי נכס, תיאור פרויקט, הערות).
        </p>
        <ul className="legal-list">
          <li>אתה מצהיר כי יש לך את כל הזכויות הנדרשות בתוכן שאתה מזין.</li>
          <li>אתה מתחייב שהתוכן אינו מפר זכויות של צדדים שלישיים, אינו פוגעני ואינו מנוגד לדין.</li>
          <li>אתה מעניק לחברה רישיון עולמי, בלתי בלעדי ובלתי הדיר להשתמש בתוכן לצורך מתן השירות, שיפורו, ניתוחו הפנימי ויצירת תובנות סטטיסטיות (בכפוף למדיניות הפרטיות).</li>
        </ul>
      </div>

      <div className="legal-section">
        <h3>10. שימוש בבינה מלאכותית</h3>
        <p className="legal-text">
          חלק מהשירות מבוסס על מודלי בינה מלאכותית (AI) ולימוד מכונה. לכן:
        </p>
        <ul className="legal-list">
          <li>התוצרים הם תוצרי חישוב הסתברותיים ועלולים לכלול טעויות, אי-דיוקים או מידע חלקי.</li>
          <li>ייתכנו הבדלים בין תוצאות שניתנות בזמנים שונים לאותו נכס/חלקה.</li>
          <li>אין לראות בתוצרים "אמת רשמית" על הנכס או על זכויות הבנייה בו.</li>
        </ul>
        <p className="legal-text">
          החברה תעשה מאמץ סביר לשפר את איכות התוצרים, אך אינה מתחייבת לדיוק מלא, לשיפור מסוים או להתאמה לצרכיך הספציפיים.
        </p>
      </div>

      <div className="legal-section">
        <h3>11. אחריות והגבלת אחריות</h3>
        <p className="legal-text">השירות ניתן במתכונת "כפי שהוא" (AS IS) ו"כפי שהוא זמין" (AS AVAILABLE). מבלי לגרוע מכלליות האמור:</p>
        <ul className="legal-list">
          <li>החברה אינה מתחייבת שהשירות יהיה זמין תמיד, ללא תקלות, ללא הפרעות או ללא שגיאות.</li>
          <li>החברה אינה אחראית לכל נזק ישיר, עקיף, תוצאתי, מיוחד או עונשי הנובע משימוש בשירות או מהסתמכות על המידע בו, לרבות הפסדי רווח, אובדן הזדמנויות, הפסדי השקעה או מקורות מימון.</li>
          <li>החברה אינה אחראית לשום פעולה שתבצע (או לא תבצע) על בסיס המידע, הדוחות או ההמלצות שהתקבלו מהשירות. האחריות המלאה להחלטותיך היא עליך בלבד.</li>
          <li>החברה אינה אחראית לתוכן, לדיוק או לעדכניות מידע שמקורו בצדדי ג' (רשויות, מאגרי מידע, ספקי נתונים וכד').</li>
        </ul>
      </div>

      <div className="legal-section">
        <h3>12. שיפוי</h3>
        <p className="legal-text">
          אתה מתחייב לשפות את החברה, עובדיה, מנהליה, בעלי מניותיה וסוכניה בגין כל נזק, הפסד, תביעה, הוצאה או עלות (לרבות הוצאות משפטיות) שייגרמו להם עקב:
        </p>
        <ul className="legal-list">
          <li>הפרת תנאים אלה על ידך.</li>
          <li>שימוש בלתי חוקי או לא מורשה בשירות.</li>
          <li>הפרת זכויות צד שלישי בקשר לתוכן שהזנת.</li>
        </ul>
      </div>

      <div className="legal-section">
        <h3>13. שינוי, השעיה והפסקת השירות</h3>
        <p className="legal-text">החברה רשאית, בכל עת וללא הודעה מוקדמת:</p>
        <ul className="legal-list">
          <li>לשנות את מבנה האתר, הממשק, היכולות, התכנים או תמחור השירות.</li>
          <li>להגביל או להפסיק את פעילות השירות, כולה או חלקה.</li>
          <li>למחוק או לשנות מידע מסוים, שכבות נתונים או פיצ'רים.</li>
        </ul>
        <p className="legal-text">
          לא תהיה לך כל טענה או דרישה כנגד החברה בשל ביצוע שינויים כאמור, כל עוד תכובד כל התחייבות מפורשת כלפיך לגבי שירותים שכבר שילמת עבורם (אם רלוונטי).
        </p>
      </div>

      <div className="legal-section">
        <h3>14. שינוי תנאי השימוש</h3>
        <p className="legal-text">
          החברה רשאית לעדכן מעת לעת את תנאי השימוש. הגרסה העדכנית תמיד תפורסם באתר ותצוין עם תאריך עדכון.
          <br />
          המשך שימושך באתר לאחר פרסום הגרסה המעודכנת יהווה הסכמה לתנאים החדשים. אם אינך מסכים/ה לשינויים – עליך להפסיק את השימוש בשירות.
        </p>
      </div>

      <div className="legal-section">
        <h3>15. דין ושיפוט</h3>
        <p className="legal-text">
          על תנאים אלה יחול הדין הישראלי בלבד, מבלי לתת תוקף לכללי ברירת דין בינלאומיים.
          <br />
          סמכות השיפוט הבלעדית בכל הנוגע לתנאים אלה ולשימוש בשירות נתונה לבתי המשפט המוסמכים במחוז תל אביב-יפו.
        </p>
      </div>

      <div className="legal-section">
        <h3>16. יצירת קשר</h3>
        <p className="legal-text">
          לשאלות, הבהרות או פניות בקשר לתנאי שימוש אלה ניתן לפנות אלינו בכתובת:
          <br />
          <strong>contact@urbanix.ai</strong>
        </p>
      </div>
    </div>
  );
};

export default TermsOfUse;

